import React, { Component } from 'react'

class RenderDelay extends Component {
    constructor() {
        super()
        this.timer = 0
        this.state = {
            render: false,
        }
    }
    componentWillUnmount() {
        clearTimeout(this.timer)
    }
    componentDidMount() {
        this.countDown()
    }
    countDown = () => {
        this.timer = setTimeout(() => this.setState({ render: true }), 1200)
    }
    render() {
        return this.state.render && <React.Fragment>{this.props.children}</React.Fragment>
    }
}

export default RenderDelay
